import React from "react";
import styles from "./ShortlistedComponent.module.scss";

const ShortlistedComponent = ({ date }) => {
  return (
    <div className={styles.shortlisted_component}>
      <p>Shortlisted on {date}</p>
    </div>
  );
};

export default ShortlistedComponent;
